"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseColumn = require("../../../../components/data-display/table/column/support/BaseColumn");
var _AggregateFunctions = require("../../../../components/data-display/table/column/support/AggregateFunctions");
var _Formatting = require("../../../../components/data-display/table/column/support/Formatting");
var _Cell = require("../cell/Cell.styled");
var CurrencyColumn = function CurrencyColumn(_) {
  return null;
};
CurrencyColumn.toColumnDef = function (child, intl) {
  var props = _objectSpread({
    align: _Cell.Align.right
  }, child.props);
  var accessorKey = props.accessorKey,
    maximumFractionDigits = props.maximumFractionDigits;
  function formatCurrency(value) {
    var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var currency = row && props.rowCurrency ? props.rowCurrency(row) : props.currency;
    return intl.formatNumber(value, {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: maximumFractionDigits || 2,
      currencyDisplay: 'narrowSymbol'
    });
  }
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(props), {
    accessorKey: accessorKey,
    cell: function cell(_ref) {
      var row = _ref.row,
        getValue = _ref.getValue;
      var value = getValue();
      var formattedValue = (0, _Formatting.dashMissingValue)(value) || formatCurrency(value, row.original);
      return (0, _BaseColumn.styledCell)(props, formattedValue);
    },
    aggregationFn: _AggregateFunctions.sum,
    footer: function footer(_ref2) {
      var table = _ref2.table;
      var value;
      if (typeof props.footer === 'number') {
        value = formatCurrency(props.footer);
      } else if (typeof props.footer === 'string') {
        value = props.footer;
      } else if (props.autoFooter && table.options.meta) {
        value = formatCurrency(table.options.meta.totals[accessorKey] || 0);
      }
      if (value !== undefined) {
        return (0, _BaseColumn.styledCell)(props, value);
      }
      return null;
    }
  });
};
var _default = exports.default = CurrencyColumn;